module.exports = __webpack_public_path__ + "img/52.7480d039.jpg";